import React from "react";
import { TCText } from "../TCText/TCText";
import { SelectedCircleOverlapPlayerAvatars } from "../selectedCircleOverlapPlayerAvatars/SelectedCircleOverlapPlayerAvatars";
import { useSelectCircleStore } from "../../stores/StoreContext";
import { PlayerCircleGraphEnum } from "../../utils/data";
import { getCirclePlayerDescription } from "../../utils/utils";

type props = {
  circle: number;
};

export const SelectedCircleInCollapsed: React.FC<props> = ({ circle }) => {
  const selectCircleStore = useSelectCircleStore();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        marginBottom: 20,
      }}>
      <div>
        <TCText
          value={`${PlayerCircleGraphEnum.getTitle(circle)} circle:`}
          style={{ fontWeight: 500, fontSize: 10, color: "white" }}
        />
        <TCText
          style={{ fontWeight: 500, fontSize: 10, color: "white" }}
          value={`${
            PlayerCircleGraphEnum.getPlayers(
              circle,
              selectCircleStore.circlePlayerResponse!
            )?.totalCount
          } ${getCirclePlayerDescription(circle)}`}
        />
      </div>
      <SelectedCircleOverlapPlayerAvatars
        total={
          PlayerCircleGraphEnum.getPlayers(
            circle,
            selectCircleStore.circlePlayerResponse!
          )?.totalCount
        }
        list={
          PlayerCircleGraphEnum.getPlayers(
            circle,
            selectCircleStore.circlePlayerResponse!
          )?.players.flatMap((player) => ({
            image: player.partnerImageUrl,
            name: player.name,
          })) ?? []
        }
      />
    </div>
  );
};
